import React, { FC, Fragment } from 'react'
import styled from 'styled-components'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Grid, GridCol } from '@ucheba/ui/components/Grid/desktop'
import { Button } from '@ucheba/ui/components/Button/desktop'
import { sv } from '@ucheba/utils/helpers/styles/variables'
import { Checkbox } from '@ucheba/ui/components/Checkbox/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import HelpIcon from '@ucheba/ui/icons/icon__help.svg'
import { Tooltip } from '@ucheba/ui/components/Tooltip/desktop/Tooltip'
import { Field, Formik } from 'formik'
import { Divider } from '@ucheba/ui/components/Divider/desktop'
import { TextField } from '@ucheba/ui/components/TextField/desktop'
import { Select } from '@ucheba/ui/components/Select/desktop'
import Loader from '@ucheba/ui/components/Loader/desktop/Loader'
import { Form } from '@ucheba/ui/components/Form/desktop'
import { ISelectDialog } from '../types'
import { useInputs } from '../../../../SelectEgeDialog/bll'
import { useInitialValues, useSelectDialog } from '../bll'

const Block = styled.div``

const Input = styled.div`
  display: flex;

  & > *:first-child {
    margin-right: ${sv.spacing.xxsmall};
  }
`

const TooltipSC = styled(Tooltip)`
  display: inline-block;
`

const HelpIconST = styled(HelpIcon)`
  cursor: help;
  position: absolute;
  top: 4px;
  left: 4px;
`

const ListElement = styled.div`
  display: flex;
`

/** Компонент для указания баллов егэ при оценке шансов */
const SelectDialog: FC<ISelectDialog> = (props) => {
  const {
    programId,
    requiredExams,
    optionalExams,
    selectedExams,
    achievements,
    onClick,
  } = props
  const inputs = useInputs()

  const initialValues = useInitialValues({
    requiredSubjects: requiredExams,
    achievementsIds: achievements,
    selectedExams,
    optionalExams,
  })

  const { onSubmit, error, isLoading } = useSelectDialog({
    programId,
    additionalSubjectsLength: optionalExams?.length,
    onClick,
  })

  return (
    <Block>
      <Heading h2='Оцените свои шансы' spacing='large' />

      <Formik enableReinitialize initialValues={initialValues} onSubmit={onSubmit}>
        {({ values }): JSX.Element => {
          return (
            <Form fillByProfile>
              {isLoading ? (
                <Loader />
              ) : (
                <>
                  <Grid>
                    <GridCol uxs={12}>
                      <Heading h3='Баллы ЕГЭ' spacing='xxsmall' />

                      <Text>
                        {`Укажите баллы по ${
                          requiredExams.length + (optionalExams?.length ? 1 : 0)
                        } предметам, можно ожидаемые`}
                      </Text>

                      <Spacing spacing='large' />

                      {values.requiredExams.map((exam, key, arr) => {
                        return (
                          <Fragment key={exam.examId}>
                            <ListElement>
                              <div
                                style={{
                                  padding: '12px 0',
                                  flex: '1',
                                }}
                              >
                                <Text firstLetterUppercase>{exam.name}</Text>
                              </div>

                              <div
                                style={{
                                  width: '96px',
                                }}
                              >
                                <Field
                                  name={`requiredExams.${key}.score`}
                                  as={TextField}
                                  // костыль чтобы валидация и ограничение работали в safari
                                  type='text'
                                  label='Баллы'
                                  pattern='[0-9]*'
                                  min={1}
                                  max={100}
                                  errorColor={error && !exam.score}
                                />
                              </div>
                            </ListElement>

                            {(arr.length - 1 !== key ||
                              (optionalExams && optionalExams?.length > 0)) && (
                              <Divider spacing='large' />
                            )}
                          </Fragment>
                        )
                      })}

                      {optionalExams && optionalExams?.length > 0 && (
                        <ListElement>
                          <div
                            style={{
                              flex: '1',
                              paddingRight: '16px',
                            }}
                          >
                            <Field
                              autocomplete
                              noItems='Такой предмет не найден'
                              items={optionalExams?.map((item) => {
                                return {
                                  name: item.name,
                                  id: item.examId,
                                }
                              })}
                              name='additionalExams'
                              keyValue='id'
                              label='Экзамен на выбор'
                              as={Select}
                              suggested
                              errorColor={
                                error &&
                                (!values?.additionalExams ||
                                  values.additionalExams.length === 0)
                              }
                            />
                          </div>

                          <div
                            style={{
                              width: '96px',
                            }}
                          >
                            <Field
                              name='additionalExamsScore'
                              as={TextField}
                              // костыль чтобы валидация и ограничение работали в safari
                              type='text'
                              label='Баллы'
                              pattern='[0-9]*'
                              min={1}
                              max={100}
                              errorColor={error && !values.additionalExamsScore}
                            />
                          </div>
                        </ListElement>
                      )}
                    </GridCol>

                    <GridCol uxs={12}>
                      <div
                        style={{
                          paddingLeft: '24px',
                        }}
                      >
                        <Heading h3='Достижения' spacing='small' />

                        {inputs.map((achieve) => (
                          <React.Fragment key={achieve.id}>
                            <Input>
                              <Field
                                firstLetterUppercase
                                type='checkbox'
                                name='achievements'
                                value={String(achieve.id)}
                                label=''
                                as={Checkbox}
                              />
                              <Text html={false} firstLetterUppercase>
                                <span>{achieve.name}</span>

                                {achieve.tooltip && (
                                  <TooltipSC
                                    width='320px'
                                    position='left-top'
                                    content={achieve.tooltip}
                                  >
                                    <div style={{ position: 'relative', height: '20px' }}>
                                      <HelpIconST
                                        width='20px'
                                        height='20px'
                                        color='rgba(3,15,35,0.5)'
                                      />
                                    </div>
                                  </TooltipSC>
                                )}
                              </Text>
                            </Input>

                            <Spacing spacing='medium' />
                          </React.Fragment>
                        ))}
                      </div>
                    </GridCol>
                  </Grid>

                  <Spacing spacing='small' />

                  {error && (
                    <>
                      <Text color='red'>
                        Выберите предметы и укажите баллы по всем предметам
                      </Text>

                      <Spacing spacing='small' />
                    </>
                  )}

                  <Button block color='blue' type='submit' progress={isLoading}>
                    Оценить шансы на поступление
                  </Button>
                </>
              )}
            </Form>
          )
        }}
      </Formik>
    </Block>
  )
}

export default SelectDialog
